import { ref } from 'vue'
import { userAgentInfo } from '../device/user-agent-info'

export const isScreenKeyboardShown = ref(false)

let switchTimeoutId: number | null = null

export function notifyScreenKeyboardShown() {
  if (!userAgentInfo.isTouchScreen) return
  if (switchTimeoutId !== null) {
    clearTimeout(switchTimeoutId)
    switchTimeoutId = null
  }

  isScreenKeyboardShown.value = true
}

export function notifyScreenKeyboardHidden() {
  switchTimeoutId = setTimeout(() => {
    isScreenKeyboardShown.value = false
    switchTimeoutId = null
  })
}
